import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Spiral Galaxy — galactic arm structure with a bright central core.
 * spiral3D + swirl3D form the arm structure, polar3D creates the
 * core, and gaussian3D adds stellar dust fill.
 */
export const example37 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Spiral Galaxy',
    description:
      'galactic arm structure with a bright central core. spiral3D + swirl3D form the arm structure, polar3D creates the core, and gaussian3D adds stellar dust fill.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -2.2,
    skipIters: 22,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitBall',
    vibrancy: 1.2,
    contrast: 4.5,
    gamma: 3.5,
    depthColorPower: 0.0,
    lightDirection: [0, 0, -1],
    lightPower: 0.1,
    highlightPower: 0.9,
    densityEstimationQuality: 0.6,
    estimatorCurve: 0.35,
    paletteMode: 0,
    palettePhase: 0.3,
    paletteSpeed: 0.55,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 0.3,
      phi: 1.1,
      radius: 2.8,
      target: [0, 0, 0],
      fov: 50,
    },
  },
  transforms: {
    [tid('3d_galaxy_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.8,
        b: 0.2,
        c: 0,
        d: 0,
        e: -0.2,
        f: 0.8,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.4,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.2, y: 0.4 },
      colorSpeed: 0.45,
      variations: {
        [vid('3d_galaxy_a_v0')]: { type: 'spiral3D', weight: 0.8 },
        [vid('3d_galaxy_a_v1')]: { type: 'swirl3D', weight: 0.4 },
      },
    },
    [tid('3d_galaxy_b')]: {
      probability: 0.3,
      preAffine: {
        a: 0.6,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.6,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.3,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.1, y: -0.2 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_galaxy_b_v0')]: { type: 'polar3D', weight: 0.7 },
        [vid('3d_galaxy_b_v1')]: { type: 'linear3D', weight: 0.5 },
      },
    },
    [tid('3d_galaxy_c')]: {
      probability: 0.2,
      preAffine: {
        a: 0.9,
        b: -0.15,
        c: 0,
        d: 0,
        e: 0.15,
        f: 0.9,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0.05,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.5, y: 0.1 },
      colorSpeed: 0.3,
      variations: {
        [vid('3d_galaxy_c_v0')]: { type: 'spiral3D', weight: 0.6 },
        [vid('3d_galaxy_c_v1')]: { type: 'gaussian3D', weight: 0.2 },
      },
    },
    [tid('3d_galaxy_d')]: {
      probability: 0.1,
      preAffine: {
        a: 0.3,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.3,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.3,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.0, y: 0.0 },
      colorSpeed: 0.2,
      variations: {
        [vid('3d_galaxy_d_v0')]: { type: 'gaussian3D', weight: 0.5 },
      },
    },
  },
})
